const getUrl = (accountId: string) => {
	return `/rest/servicedesk/notifications/1/email/unsuppress/${accountId}`;
};

export const unblockSuppressedEmail = async (accountId: string) => {
	const response = await fetch(getUrl(accountId), {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	if (!response.ok) {
		const body = await response.json();
		throw new Error(body.errors[0].errorMessage);
	}
};
